import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import Popup from '../Popup';
import LoginForm from '../Form/LoginForm';
import Logo from '../Logo';
import loginBg from '../../assets/login_image.png';
import logoLong from '../../assets/cps_new.svg';
import icon_CPS from '../../assets/icon_cps.svg';

import { connect } from 'react-redux';
import { compose, withHandlers, lifecycle } from 'recompose';

import { Field, reduxForm } from 'redux-form';

import { loginAdminRequest, loginRequest, loginReset, getTokenFromCookies } from '../../redux/reducers/login';

import { commonStyles } from '../../styles/styles';
import EmailField from '../Form/EmailField';
import PasswordField from '../Form/PasswordField';
import { validateLogin } from '../Form/validate'; 

import { MDBContainer, MDBRow, MDBCol, MDBCard, MDBCardBody, MDBInput, MDBBtn, MDBIcon, MDBModalFooter, MDBNotification } from 'mdbreact';
import ModalPopup from './ModalPopup';
import authHOC from '../AuthHOC';


const LoginPopup = ({ classes, handleForgottenPopup, handleRegistrationPopup,handleSubmit, submitting, handleSubmitLogin, loginReducer, isDeactivated }) => (
  <MDBContainer fluid>
    <div className="mainBg"></div>
      <MDBRow center  style={{alignItems: 'center', display: 'flex', height: '100vh'}}>
        <MDBCol md="6">
          <MDBCard>
            <div className="header pt-3">
              <MDBRow>
                <h3 className="gotham-bold w-100 lg-text mt-2 mb-2 pb-1 mx-5">
                    Login
                </h3>
                <img className="icon_CPS" src={icon_CPS} />
              </MDBRow>
            </div>
            <MDBCardBody className="mt-4">
              <form onSubmit={handleSubmit(handleSubmitLogin)} className={classes.form}>
               
                {isDeactivated && <Typography className={classes.formError}>You account has been successfully deactivated</Typography>}
                <MDBRow center className="w-100">
                  <MDBCol lg="10" className="w-100">
                    <Field name="Email" label="Email" component={EmailField} />
                  </MDBCol>
                </MDBRow>
                <MDBRow center className="w-100">
                  <MDBCol lg="10" className="w-100">
                    <Field name="Password" type="password" label="Password" id={Date.now().toString()} component={PasswordField} />
                  </MDBCol>
                </MDBRow>
             <MDBRow center className="w-100 pt-4">
                <MDBCol lg="12" className="left">
                  <div style={{height:40}} className="font-small grey-text pt-1">
                    <div onClick={event => handleForgottenPopup(event)}
                      className="font-weight-bold ml-1" style={{cursor:'pointer'}}>
                      Forgot Password?
                    </div>
                  </div>
                </MDBCol>
                <MDBCol lg="12" >
                    <MDBBtn
                      color="yellow-new"
                      right
                      className='ml-auto ml-4 mt-0 w-100 mb-2'
                      action
                      type="submit"
                      disabled={submitting}>
                      Login
                    </MDBBtn>
                </MDBCol>
                
              </MDBRow>
              {loginReducer.error && 
              <ModalPopup type='error' color='secondary' title='Error' body='Your login details have not been successful.'/>
               }
            </form>
              
              
              <div className="md-text grey-text d-flex justify-content-center pt-2" >
                Don't have an account?
                <div
                
                  className="grey-text gotham-bold ml-1"
                  onClick={event => handleRegistrationPopup(event)}
                  style={{cursor:'pointer'}}
                >
                  Create one here
                </div>
              </div>
             
            </MDBCardBody>
          </MDBCard>
        </MDBCol>
      </MDBRow>
      
    </MDBContainer>
  // <Popup>
  //    {}
  //   <div className={classes.popupWrapper}>
  //     <div className={classes.popupContainer}>
  //       <div className={classes.leftSide} style={{ backgroundImage: `url(${loginBg})` }}>
  //         <Logo className={classes.logoPopup} wideLogo />
  //       </div>
  //       <div className={classes.rightSide}>
  //         <div className={classes.topPart}>
  //           <Typography variant="headline" gutterBottom className={classes.popupSubtitle}>
  //             Login
  //           </Typography>
  //           
  //           <div className={classes.forgotLink}>
  //             <Typography
  //               onClick={event => handleForgottenPopup(event)}
  //               variant="caption"
  //               className={classes.forgotLinkText}
  //             >
  //               Forgot password?
  //             </Typography>
  //             <Typography variant="caption" className={classes.registrationCaption}>
  //           {"Don't have an account? Create one "}
  //           <Typography
  //             className={classes.registrationLink}
  //             onClick={event => handleRegistrationPopup(event)}
  //           >
  //             here
  //           </Typography>
  //         </Typography>
  //           </div>
  //         </div>
          
  //       </div>
  //     </div>
  //   </div>
  // </Popup>
);
LoginPopup.propTypes = {
  classes: PropTypes.instanceOf(Object),
  handleRegistrationPopup: PropTypes.func,
  handleForgottenPopup: PropTypes.func,
};

LoginForm.propTypes = {
  classes: PropTypes.instanceOf(Object),
  handleSubmit: PropTypes.func,
  submitting: PropTypes.bool,
  handleSubmitLogin: PropTypes.func,
  
};

const mapStateToProps = state => ({
  formState: state.form,
  loginReducer: state.loginReducer,
});
const mapDispatchToProps = dispatch => ({
  loginRequest: () => dispatch(loginRequest()),
  loginReset: () => dispatch(loginReset()),
  loginAdminRequest: (obj) => dispatch(loginAdminRequest(obj)),
  getToken: token => dispatch(getTokenFromCookies(token)),
});

const styles = () => ({
  ...commonStyles,
  form: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    paddingTop: 10,
   
  },
});

export default compose(
  reduxForm({
    form: 'login',
  }),
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withHandlers({
    handleSubmitLogin: props => values => {
      
      props.loginReset();
      validateLogin(values);
      props.loginRequest();
    },
  }),
  lifecycle({
    componentWillUnmount() {
      if (this.props.loginReducer.error) {
        this.props.loginReset();
      }
    },
  }),
  withStyles(styles),
)(LoginPopup);



// WEBPACK FOOTER //
// ./src/Components/Popups/LoginPopup.jsx